import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import * as React from "react";

import "./MoreActionButtonStyleSheet.css"

export default function CustomBackButton({handleClose}) {
    return (
        <button className="btn-secondary-action" onClick={handleClose}><ArrowBackIosIcon fontSize="small"/></button>
    )
}